// extracted by mini-css-extract-plugin
export var main = "index-module--main--64534";
export var rotating = "index-module--rotating--1d6ae";
export var viewport = "index-module--viewport--9a13b";